import {Directive, DoCheck, ElementRef, Input, OnChanges, SimpleChanges} from "@angular/core";

@Directive({
	selector: "[appFadeToggle]",
	standalone: false,
})
export class FadeToggleDirective implements DoCheck {
	@Input() isFadedOut = false;

	private currentState = false;
	private fading: boolean = false;

	constructor(readonly element: ElementRef) {
		this.element = element.nativeElement;
		console.log(this.element);
	}

	ngDoCheck(): void {
		if (!this.fading && this.currentState !== this.isFadedOut) {
			this.toggleDim();
		}
	}

	private toggleDim() {
		if (this.fading) return;
		this.fading = true;

		if (this.isFadedOut) {
			$(this.element)
				.fadeOut()
				.promise()
				.then(() => {
					this.fading = false;
					this.currentState = true;
				});
		} else if (!this.isFadedOut) {
			$(this.element)
				.fadeIn()
				.promise()
				.then(() => {
					this.fading = false;
					this.currentState = false;
				});
		}
	}
}
